import React, {Component} from 'react';
import _ from 'lodash';

export default class FullHistoryStructure extends Component {

  constructor(props){
    super(props)

    this.renderWorkflowProcessHistory = this.renderWorkflowProcessHistory.bind(this);
    this.renderNextWorkflowProcess = this.renderNextWorkflowProcess.bind(this);
    this.renderCampusNextWorkflowProcess = this.renderCampusNextWorkflowProcess.bind(this);
  }

  renderWorkflowProcessHistory(history_row){
    const self = this;
    const is_active = this.props.active_history === `wp-${history_row.workflow_process_id}-history-${history_row.wph_id}`;

    return (
      <li key={history_row.wph_id} 
          className="py-1 pointer"
          onClick={(event) => this.props.onFocusHistory(history_row, event)}>
        {_.isEmpty(history_row.action_name) ? (
          <span className='fa fa-envelope-o mr-1'></span>
        ) : (
          <span className='fa fa-check-square-o mr-1'></span>
        )}

        <span className={`mr-3 px-1 ${ is_active && "bg-info" }`}>
          {history_row.state_name}

          {!_.isEmpty(history_row.action_name) && (
            <strong> - {history_row.action_name}</strong>
          )}
        </span>

        {_.map(history_row.next_workflow_processes, function(next_workflow_process, index){
          if(next_workflow_process.campus){
            return(self.renderCampusNextWorkflowProcess(next_workflow_process))
          } else {
            return(self.renderNextWorkflowProcess(next_workflow_process))
          }
        })}
      </li>
    )
  }

  renderNextWorkflowProcess(nextWorkflowProcess){
    return(
      <div key={nextWorkflowProcess.workflow_process_id} className="pl-4 py-2">
        {nextWorkflowProcess.current_state_name == "เอกสารรอบันทึกรับ" ? (
          <span className='fa fa-envelope-o mr-1'></span>
        ) : (
          <span className='fa fa-check-square-o mr-1'></span>
        )}

        <strong>{nextWorkflowProcess.current_department} ({nextWorkflowProcess.current_state_name})</strong>

        <ul key={nextWorkflowProcess.workflow_process_id} className='ul-group-list pl-4 py-1'>
          {_.map(nextWorkflowProcess.all_history, this.renderWorkflowProcessHistory)}
        </ul>
      </div>
    )
  }

  renderCampusNextWorkflowProcess(nextWorkflowProcess){
    return(
      <div  key={`${nextWorkflowProcess.workflow_process_id}-campus${nextWorkflowProcess.campus_code}`} 
            className="pl-4 py-2"
            onClick={(event) => this.props.onFocusCampusHistory(nextWorkflowProcess.campus_code, nextWorkflowProcess.workflow_process_id, event)}>
        {nextWorkflowProcess.current_state_name == "เอกสารรอบันทึกรับ" ? (
          <span className='fa fa-envelope-o mr-1'></span>
        ) : (
          <span className='fa fa-check-square-o mr-1'></span>
        )}

        <strong>{nextWorkflowProcess.current_department} ({nextWorkflowProcess.current_state_name})</strong>
      </div>
    )
  }

  render(){
    return (
      <div className='mt-3'>
        <strong>{this.props.current_department} ({this.props.current_state_name})</strong>

        {!_.isEmpty(this.props.all_history) && (
          <ul key={this.props.workflow_process_id} className='ul-group-list'>
            {_.map(this.props.all_history, this.renderWorkflowProcessHistory)}
          </ul>
        )}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/FullHistory/FullHistoryStructure.js